<template>
    <div class="ds-glass-scrim z-[60]" v-if="isActive" @click="close"></div>
    <div
        ref="panel"
        class="side-panel fixed bg-white h-screen top-0 right-0 w-[500px] z-[61] transition-transform duration-300 border-t border-grayxlight"
        @transitionend="onTransitionEnd"
        :class="{
            'transform translate-x-full': !isActive,
            'side-panel--glass': isActive
        }"
    >
        <button @click="close" :disabled="locked" :class="{ 'opacity-50 cursor-not-allowed': locked }" class="absolute top-[9px] right-[10px] text-gray">
            <icon>
                <IconClose />
            </icon>
        </button>
        <slot v-if="isActive"></slot>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import IconClose from '../../ui/icons/IconClose.vue'
// locked — пока операция содержимого не завершена, пользователь не закрывает панель (крестик/затемнение).
// Программное toggle() владельца работает всегда. По умолчанию false — прежнее поведение.
const { locked = false } = defineProps<{ locked?: boolean }>()
const isActive = ref(false)
const panel = ref<HTMLElement | null>(null)
const emit = defineEmits(['close', 'opened'])
const toggle = () => isActive.value = !isActive.value
const close = () => {
    if (locked) return
    isActive.value = false
    emit('close')
}
const onTransitionEnd = (event: TransitionEvent) => {
    if (event.propertyName === 'transform' && isActive.value) emit('opened')
}

defineExpose({
    toggle,
    close,
    panel
});
</script>

<style scoped>
/* Поверхность B «Стекло» (RD-148) — общая для всех consumers панели. */
.side-panel--glass {
    border-color: var(--glass-b-border);
    background: var(--glass-b-panel-surface);
    box-shadow: var(--glass-b-panel-shadow);
    -webkit-backdrop-filter: var(--glass-b-panel-filter);
    backdrop-filter: var(--glass-b-panel-filter);
}

@supports not ((backdrop-filter: blur(1px)) or (-webkit-backdrop-filter: blur(1px))) {
    .side-panel--glass {
        background: var(--color-bg-surface);
    }
}
</style>
